import {
    FETCH_ALL_USERS_REQUEST,
    FETCH_ALL_USERS_SUCCESS,
    FETCH_ALL_USERS_FAILURE,
    FETCH_USER_BY_ID_REQUEST,
    FETCH_USER_BY_ID_SUCCESS,
    FETCH_USER_BY_ID_FAILURE
} from '../actions/user-actions';

const initialState = {
    users: [],
    selectedUser: null,
    loading: false,
    error: null
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ALL_USERS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_ALL_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                users: action.payload,
                error: null
            };
        case FETCH_ALL_USERS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case FETCH_USER_BY_ID_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_USER_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedUser: action.payload,
                error: null
            };
        case FETCH_USER_BY_ID_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
};

export default userReducer;
